import { isValidNumber } from '@gp/utils/common';

// 处理Headcounts模块、Headcount Cost模块、5Y Headcounts模块 接口返回数据
export const handleDatas = (responseRes: any): any => {
  // const data = responseRes?.data?.data;
  const data = responseRes;
  if (!Array.isArray(data) || !data?.length) return null;
  try {
    const metrics: string[] = [],
      dataList: { [key: string]: string }[] = [];
    for (let index = 0; index < data?.length; index++) {
      const item = data?.[index];
      const metricList: { [key: string]: string } = {};
      let valueType = '', total = '';
      for (let i = 0; i < item?.management_team?.length; i++) {
        const t: {
          management_team: string,
          value: string,
          actual_or_forecast: string, // 1: actual 2: forecast
        } = item?.management_team?.[i];
        if (['1', '2']?.includes(t?.actual_or_forecast) && !valueType) {
          valueType = t?.actual_or_forecast == '1' ? 'actual' : 'forecast';
        }
        metricList[t.management_team] = t?.value;
        if (isValidNumber(t?.value)) {
          total = String(Number(total) + Number(t?.value));
        }
        metrics.includes(t.management_team) || metrics.push(t.management_team);
      }
      dataList.push({
        valueType,
        date: item.date,
        total,
        ...metricList,
      });
    }
    // 把Others固定排在最后
    if (metrics.includes('Others')) {
      const index = metrics.indexOf('Others');
      metrics.splice(index, 1);
      metrics.push('Others');
    }

    return {
      // isSuccessReq: responseRes?.status === 200 && responseRes?.data?.code === 200,
      isSuccessReq: true,
      metrics,
      dataList,
    };
  } catch (error) {
    console.error(error);
    return null;
  }
};

// 表格排序时参数月份补齐-01
export const formatMonth = (data: string): string => {
  if (!data || typeof data !== 'string') return '';
  return `${data}-01`;
}
